<div class="content-grid mdl-grid optionb" >
    <div class="mdl-cell mdl-cell--9-col mdl-cell--12-col-phone mdl-cell--12-col-tablet" text-color="gray-dark">
        <h2 class="h2" text-color="gray-dark">{{'HIGHLIGHTS' | translate}}</h2>
        <ul>
            <li *ngFor="let highlight of product?.highlights">
                {{highlight.name}}
            </li>
        </ul>
    </div>    
</div>